export default class CustomerContact {
  constructor() {
    this.name = null
    this.telephone = null
    this.mobile = null
    this.email = null
  }
}
